import React, { useState, useEffect } from 'react';
import ImageWithBasePath from '../../../core/common/imageWithBasePath';

interface FilterPopupProps {
    selectedCard: any;
    closeModal: () => void;
    onApplyFilters: (filters: {
        destinations: string[];
        // levels: string[]
    }) => void;
    apiValues: any
}



const FilterPopup: React.FC<FilterPopupProps> = ({ selectedCard, closeModal, onApplyFilters, apiValues }) => {
    const [selectedCountries, setSelectedCountries] = useState<string[]>([]);
    const [selectedLevels, setSelectedLevels] = useState<string[]>([]);

    const destinations = apiValues || []

    // [
    //     { id: 'us', label: 'USA' },
    //     { id: 'uk', label: 'UK' },
    //     { id: 'ca', label: 'Canada' },
    // ];

    // const levels = apiValues?.levels || []
    // [
    //     { id: 'ug', label: 'Undergraduate' },
    //     { id: 'pg', label: 'Postgraduate' },
    //     { id: 'phd', label: 'PhD' },
    // ];
    useEffect(() => {
        if (!selectedCard) return;

        // Reset filters when card is clicked
        setSelectedCountries([]);
        setSelectedLevels([]);
    }, [selectedCard]);

    if (!selectedCard) return null; // Don't render popup if nothing selected

    const handleCountryChange = (id: string) => {
        setSelectedCountries(prev =>
            prev.includes(id) ? prev.filter(i => i != id) : [...prev, id]
        );
    };

    const handleLevelChange = (id: string) => {
        setSelectedLevels(prev =>
            prev.includes(id) ? prev.filter(i => i != id) : [...prev, id]
        );
    };

    const applyFilters = () => {
        onApplyFilters({
            destinations: selectedCountries,
            // levels: selectedLevels
        });
        closeModal();
    };

    return (
        <div className="fixed inset-0 bg-gray-100 bg-opacity-40 z-50 flex justify-center items-center">
            <div className="bg-white rounded-lg p-6 w-[100%] max-w-md shadow-lg relative">
                <button onClick={closeModal} className="absolute top-2 right-2 text-gray-500 hover:text-black">✕</button>

                <h2 className="text-lg font-semibold mb-4">Filters for: {selectedCard.label}</h2>

                <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-2">
                    {/* <h3 className="font-medium mb-2">Select Countries</h3> */}
                    {destinations.map((country: any) => (
                        <label key={country._id} className="mr-2 text-center space-x-1">

                            <div className='flex items-center gap-1  mb-1'>
                                <input
                                    type="checkbox"
                                    checked={selectedCountries.includes(country._id)}
                                    onChange={() => handleCountryChange(country._id)}
                                />
                                <div className='flex items-center ' >  
                                     <span className="avatar avatar-rounded">
                                    <ImageWithBasePath
                                        className="border border-white"
                                        source={country?.countryImage}
                                        alt="img"
                                    />
                                </span>

                                    {country?.countryName}
                                </div>

                            </div>
                            {/* <span>{country.countryName}</span> */}
                        </label>
                    ))}
                </div>

                {/* <div className="mb-4">
                    <h3 className="font-medium mb-2">Select Study Levels</h3>
                    {levels.map((level:any) => (
                        <label key={level._id} className="mr-2 space-x-2">
                            <input
                                type="checkbox"
                                checked={selectedLevels.includes(level._id)}
                                onChange={() => handleLevelChange(level._id)}
                            />
                            <span>{level.levelName}</span>
                        </label>
                    ))}
                </div> */}

                <button
                    onClick={applyFilters}
                    className="bg-[#EA1D2A] text-white px-4 py-2 rounded hover:bg-red-600 transition"
                >
                    Apply Filters
                </button>
            </div>
        </div>
    );
};

export default FilterPopup;
